import { useSelector } from "react-redux";

const useDynamicValidation = (validationStatus, form, useDynamicForm) => {
  const visibilityMap = useSelector(
    (state) => state.formVisibility.formVisibilityMap[form],
  );

  if (!useDynamicForm) {
    return {};
  }

  const dynamicValidationStatus = {};
  if (visibilityMap) {
    for (const vo of Object.values(visibilityMap)) {
      if (vo.fieldName && vo.validate === 1 && validationStatus[vo.fieldName]) {
        let currentValidationStatus = validationStatus[vo.fieldName];
        if (
          currentValidationStatus !== null &&
          currentValidationStatus.changeWhenMandatory
        ) {
          currentValidationStatus =
            vo.mandatory === 1
              ? {
                  validators: [...currentValidationStatus.mandatoryValidators],
                  name: currentValidationStatus.name,
                }
              : {
                  validators: [
                    ...currentValidationStatus.nonMandatoryValidators,
                  ],
                  name: currentValidationStatus.name,
                };
        }
        dynamicValidationStatus[vo.fieldName] = currentValidationStatus;
      }
    }
  }

  return visibilityMap ? dynamicValidationStatus : validationStatus;
};

export default useDynamicValidation;
